/* eslint-disable no-console */
import { cls } from '@react/utils/classname'
import { useContext } from 'react'

import { useUserInfo } from '../../User/useUserInfo'
import { ButtonsWrapper } from '../Components/ButtonsWrapper'
import { Teaser } from '../Components/Teaser'
import { Testimonial } from '../Components/Testimonial'
import { FilterableListContext } from '../FilterableListContext'
import { ItemType } from '../FilterableListTypes'
import { Card } from '../UI/Card'
import { ListTypeItem } from '../UI/ListTypeItem'

export const News = () => {
  const { responseData, propsState, translationsState } = useContext(FilterableListContext)

  const items = responseData?.items ?? []

  // effectiveStyle: 'list' when user toggled to list view; otherwise use CMS-configured listStyle (teaser/card/testimonial)
  const effectiveStyle = propsState.listStyleTemplate === 'list' ? 'list' : propsState.listStyle || 'teaser'
  const listStyleClassName = effectiveStyle ? `cmp-filterable-list__news-type--${effectiveStyle}` : ''
  const teaserColumnsClassName = propsState.teaserColumns ? `cmp-filterable-list--${propsState.teaserColumns}-columns` : ''

  // Only call useUserInfo hook if in PowerPortal shell to avoid unnecessary API calls
  const isPowerPortalShell = document.body?.classList?.contains('cmp-powerportal-main')
  const { userDetails, isLoading } = isPowerPortalShell
    ? useUserInfo()
    : { userDetails: { currentUser: null, powerPortalProfile: null }, isLoading: false }

  const userCountryCode = userDetails.powerPortalProfile?.samlAttributes?.countryCode
  const prioritizedItems = (() => {
    if (!isPowerPortalShell || isLoading) {
      return items
    }

    if (!userCountryCode) {
      return items
    }

    const normalizedCountry = userCountryCode.toLowerCase()
    const preferred: ItemType[] = []
    const others: ItemType[] = []

    items.forEach(item => {
      const tags = (item as { enabledCountryTags?: string[] }).enabledCountryTags ?? []
      const extractedCountryCodes = tags.map(tag => tag?.split('/')?.pop()?.toLowerCase()).filter(Boolean) as string[]
      const matchesCountry = extractedCountryCodes.includes(normalizedCountry)
      if (matchesCountry) {
        preferred.push(item)
      } else {
        others.push(item)
      }
    })
    return [...preferred, ...others]
  })()
  const renderComponent = (item: ItemType, index: number, listStyle = 'teaser') => {
    switch (listStyle) {
      case 'teaser':
        return <Teaser item={item} key={`${index}-${item.title}`} showMetaTag={false} buttonLabel={translationsState.readMoreLabel} />

      case 'card':
        return (
          <Card item={item} key={`${index}-${item.title}`} showMetaDate={true} showMetaTag={false} buttonLabel={translationsState.readMoreLabel} />
        )

      case 'list':
        return <ListTypeItem item={item} key={`${index}-${item.title}`} showButton={true} buttonLabel={translationsState.readMoreLabel} />

      case 'testimonial':
        return <Testimonial item={item} key={`${index}-${item.title}`} buttonLabel={translationsState.readMoreLabel} />

      default:
        return <p>List style do not exist</p>
    }
  }

  return (
    <div className="cmp-filterable-list">
      <div
        className={cls({
          'cmp-filterable-list__list': effectiveStyle === 'list',
          'cmp-filterable-list__cards': effectiveStyle !== 'list',
          [listStyleClassName]: effectiveStyle,
          [teaserColumnsClassName]: propsState.teaserColumns,
        })}
      >
        {prioritizedItems.map((item, index) => {
          return renderComponent(item, index, effectiveStyle)
        })}
      </div>
      {propsState.buttonAlignment !== 'right' && <ButtonsWrapper url={propsState.seeAllLink} linkText={translationsState.filterbarShowAll} />}
    </div>
  )
}
